import { Numeric0CircleOutlineIcon } from './Numeric0CircleOutlineIcon';

/**
 * author: Contributors
 * id BB859C27-AAAC-4ED4-A50B-45427C15CF05
 * name numeric-0-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-0-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumberZeroCircleOutlineIcon = Numeric0CircleOutlineIcon;
export default NumberZeroCircleOutlineIcon